var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "articleModal",
          attrs: {
            visible: _vm.visible,
            title: _vm.pram.id ? "编辑活动" : "新增活动",
            top: "100px",
            width: "800px",
            "destroy-on-close": "",
            modal: false,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { ref: "pram", attrs: { "label-width": "160px", model: _vm.pram } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "活动名称：",
                    prop: "name",
                    rules: [
                      {
                        required: true,
                        message: "请填写活动名称",
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请填写活动名称" },
                    model: {
                      value: _vm.pram.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "name", $$v)
                      },
                      expression: "pram.name",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "活动状态：",
                    prop: "status",
                    rules: [
                      {
                        required: true,
                        message: "请选择活动状态",
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { size: "small" },
                      model: {
                        value: _vm.pram.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.pram, "status", $$v)
                        },
                        expression: "pram.status",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("开启")]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("关闭")]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "活动横图：",
                    prop: "image",
                    rules: [
                      {
                        required: true,
                        message: "请上传活动横图",
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: { display: "flex", "align-items": "center" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "upLoadPicBox",
                          on: {
                            click: function ($event) {
                              return _vm.modalPicTap("1", "image")
                            },
                          },
                        },
                        [
                          _vm.pram.image
                            ? _c("div", { staticClass: "pictrue" }, [
                                _c("img", { attrs: { src: _vm.pram.image } }),
                              ])
                            : _c("div", { staticClass: "upLoad" }, [
                                _c("i", {
                                  staticClass: "el-icon-camera cameraIconfont",
                                }),
                              ]),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.pram.image
                        ? _c("i", {
                            staticClass: "el-icon-delete",
                            staticStyle: { color: "red", "font-size": "16px" },
                            on: {
                              click: function ($event) {
                                return _vm.removeImg("image")
                              },
                            },
                          })
                        : _vm._e(),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "活动产品（skuID）：",
                    prop: "skuIds",
                    rules: [
                      {
                        required: true,
                        message: "请填写活动产品（skuID）",
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      clearable: "",
                      type: "textarea",
                      rows: 4,
                      resize: "none",
                      placeholder: "请输入skuId",
                    },
                    model: {
                      value: _vm.pram.skuIds,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "skuIds", $$v)
                      },
                      expression: "pram.skuIds",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticStyle: { color: "#666" } }, [
                    _vm._v(
                      "输入skuId，多个以逗号分隔（示例：30001,30002,30003）"
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.loading },
                  on: {
                    click: function ($event) {
                      return _vm.handerSubmit("pram")
                    },
                  },
                },
                [_vm._v("保存")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "link" }, on: { click: _vm.closeEdit } },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }